export function reconcileMerchantRailOrder(
  previous: ReadonlyArray<string>,
  incoming: ReadonlyArray<string>,
) {
  const valid = new Set(incoming);
  return [
    ...previous.filter((id) => valid.has(id)),
    ...incoming.filter((id) => !previous.includes(id)),
  ];
}

export function moveMerchantRailItem(
  order: ReadonlyArray<string>,
  id: string,
  direction: "up" | "down",
) {
  const currentIndex = order.indexOf(id);
  const nextIndex = currentIndex + (direction === "up" ? -1 : 1);
  if (currentIndex < 0 || nextIndex < 0 || nextIndex >= order.length) {
    return [...order];
  }
  const next = [...order];
  next.splice(currentIndex, 1);
  next.splice(nextIndex, 0, id);
  return next;
}
